import "./sentry-config";
import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/main.css";
import "./components/course-details/ManageContent.css";
import "./components/course-details/courseMedia.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/css/ChatMod.scss";
import "./assets/css/upload.css";
import "./assets/css/Profile.scss";
import "../src/pages/auth/newauth/NewLogin.css";
import ErrorBoundary from "./pages/Error/ErrorBoundary";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode >
    <ErrorBoundary>
    <App />
    </ErrorBoundary>
 </React.StrictMode>
);
reportWebVitals();
